import EmailIcon from '@mui/icons-material/Email';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import CardText from 'components/Card/Text';
import CardTitle from 'components/Card/Title';

import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';

const Inactive = ({ onLogin }) => (
  <>
    <CardTitle title='Cannot Sign In' />
    <CardText noTopPadding>
      Your account is no longer active. Please contact support to regain access.
    </CardText>
    <CardText noTopPadding>
      <SecondaryButton
        label='Back to login'
        onClick={onLogin}
      />
    </CardText>
    <PrimaryButton
      fullWidth
      href='https://help.ripplestreet.com'
      icon={useMemo(
        () => <EmailIcon />,
        [],
      )}
      label='Contact Support'
    />
  </>
);

Inactive.propTypes = {
  onLogin: PropTypes.func.isRequired,
};

export default Inactive;
